import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useSettings } from '../context/SettingsContext';
import api, { getImageUrl } from '../services/api';

export default function Header() {
  const { settings } = useSettings();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get('/services')
      .then(res => setServices(res.data))
      .catch(err => console.error('Services fetch error:', err));
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  const isServiceActive = () =>
    location.pathname.startsWith('/hizmetler') ? 'active' : '';

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="logo">
          {settings.logo_path ? (
            <img src={getImageUrl(settings.logo_path)} alt={settings.site_title || 'Logo'} className="logo-img" />
          ) : (
            settings.site_title || 'Site'
          )}
        </Link>

        <button
          className="nav-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          <Link to="/" className={isActive('/')}>
            ANASAYFA
          </Link>
          <Link to="/sayfa/hakkimizda" className={isActive('/sayfa/hakkimizda')}>
            KURUMSAL
          </Link>

          <div className={`nav-dropdown ${dropdownOpen ? 'open' : ''}`}>
            <button
              className={`nav-dropdown-toggle ${isServiceActive()}`}
              onClick={() => setDropdownOpen(!dropdownOpen)}
              type="button"
            >
              HIZMETLER
            </button>
            <div className="nav-dropdown-menu">
              {services.map((service) => (
                <Link
                  key={service.id}
                  to={`/hizmetler/${service.slug}`}
                >
                  {service.title}
                </Link>
              ))}
            </div>
          </div>

          <Link to="/referanslar" className={isActive('/referanslar')}>
            REFERANSLAR
          </Link>
          <Link to="/sizden-gelenler" className={isActive('/sizden-gelenler')}>
            SİZDEN GELENLER
          </Link>
          <Link to="/iletisim" className={isActive('/iletisim')}>
            İLETİŞİM
          </Link>
          <Link to="/teklif-al" className={`nav-quote-btn ${isActive('/teklif-al')}`}>
            TEKLIF AL
          </Link>
        </nav>
      </div>
    </header>
  );
}
